module.exports = __webpack_public_path__ + "img/bnr_challenge_top_side_3_active.12373d76.png";